"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _createStarExport(obj) { Object.keys(obj) .filter((key) => key !== "default" && key !== "__esModule") .forEach((key) => { if (exports.hasOwnProperty(key)) { return; } Object.defineProperty(exports, key, {enumerable: true, configurable: true, get: () => obj[key]}); }); }















var _fetch = require('./fetch');







var _alerts = require('./alerts'); _createStarExport(_alerts);

 class FetchCommands extends _fetch.Fetch {
  

  constructor (baseURL, restClientMetadata) {
    super(baseURL);FetchCommands.prototype.__init.call(this);FetchCommands.prototype.__init2.call(this);FetchCommands.prototype.__init3.call(this);FetchCommands.prototype.__init4.call(this);FetchCommands.prototype.__init5.call(this);FetchCommands.prototype.__init6.call(this);FetchCommands.prototype.__init7.call(this);FetchCommands.prototype.__init8.call(this);FetchCommands.prototype.__init9.call(this);FetchCommands.prototype.__init10.call(this);FetchCommands.prototype.__init11.call(this);FetchCommands.prototype.__init12.call(this);FetchCommands.prototype.__init13.call(this);FetchCommands.prototype.__init14.call(this);FetchCommands.prototype.__init15.call(this);FetchCommands.prototype.__init16.call(this);FetchCommands.prototype.__init17.call(this);FetchCommands.prototype.__init18.call(this);FetchCommands.prototype.__init19.call(this);FetchCommands.prototype.__init20.call(this);FetchCommands.prototype.__init21.call(this);FetchCommands.prototype.__init22.call(this);FetchCommands.prototype.__init23.call(this);FetchCommands.prototype.__init24.call(this);FetchCommands.prototype.__init25.call(this);FetchCommands.prototype.__init26.call(this);FetchCommands.prototype.__init27.call(this);FetchCommands.prototype.__init28.call(this);FetchCommands.prototype.__init29.call(this);FetchCommands.prototype.__init30.call(this);FetchCommands.prototype.__init31.call(this);FetchCommands.prototype.__init32.call(this);FetchCommands.prototype.__init33.call(this);FetchCommands.prototype.__init34.call(this);FetchCommands.prototype.__init35.call(this);FetchCommands.prototype.__init36.call(this);FetchCommands.prototype.__init37.call(this);FetchCommands.prototype.__init38.call(this);FetchCommands.prototype.__init39.call(this);FetchCommands.prototype.__init40.call(this);
    this.restClientMetadata = restClientMetadata
  }

   __init() {this.authMetadata = () => this.restClientMetadata}

  __init2() {this.csrf = (signal) =>
    this.fetch('/csrf', 'GET', null, null, signal)}

  __init3() {this.login = (email, password, longlived = false, headerDispatch) =>
    this.fetch('/login', 'POST', { email, password, longlived, ...this.authMetadata() }, headerDispatch)}

  __init4() {this.sendLoginMFAPhoneCode = (challengeKey, phone) =>
    this.fetch('/login/mfa/send_phone_code', 'POST', {
      challenge_key: challengeKey,
      phone,
    })}

  __init5() {this.resendLoginMFACode = (challengeKey) =>
    this.fetch('/login/mfa/resend', 'POST', { challenge_key: challengeKey })}

  __init6() {this.verifyLoginMFA = (
    challengeKey,
    code,
    longlived = false,
    headerDispatch,
  ) =>
    this.fetch('/login/mfa/verify', 'POST', {
      challenge_key: challengeKey,
      code,
      longlived,
    }, headerDispatch)}

  // Passwordless patient sign-in. `deviceId` is optional throttling context.
  __init7() {this.patientLoginStart = (identifier, deviceId) =>
    this.fetch('/patient/login/start', 'POST', {
      identifier,
      ...(deviceId ? { device_id: deviceId } : {}),
    })}

  __init8() {this.patientLoginResend = (challengeKey, deviceId) =>
    this.fetch('/patient/login/resend', 'POST', {
      challenge_key: challengeKey,
      ...(deviceId ? { device_id: deviceId } : {}),
    })}

  // Success has the staff /login body and cookies, so it goes through the same
  // cookie dispatch and loginSuccess bootstrap.
  __init9() {this.patientLoginVerify = (
    challengeKey,
    code,
    longlived = true,
    headerDispatch,
    deviceId,
  ) =>
    this.fetch('/patient/login/verify', 'POST', {
      challenge_key: challengeKey,
      code,
      longlived,
      ...(deviceId ? { device_id: deviceId } : {}),
      ...this.authMetadata(),
    }, headerDispatch)}

  __init10() {this.sendSignupMFAPhoneCode = (token, phone) =>
    this.fetch('/signup/mfa/send_phone_code', 'POST', {
      token,
      phone,
    })}

  __init11() {this.resendSignupMFACode = (challengeKey) =>
    this.fetch('/signup/mfa/resend', 'POST', { challenge_key: challengeKey })}

  __init12() {this.verifySignupMFA = (
    challengeKey,
    code,
  ) =>
    this.fetch('/signup/mfa/verify', 'POST', {
      challenge_key: challengeKey,
      code,
    })}

  __init13() {this.getFileLink = (key) => this.fetch(`/get_file_link?key=${key}`)}
  /** Like getFileLink, but the Link makes storage serve the file as an
   * attachment with its original name, so a browser saves it. Every Download
   * uses it, so the server's access log tells a download from a preview. */
  __init14() {this.getFileDownloadLink = (key) =>
    this.fetch(`/get_file_link?download=true&key=${key}`)}

  __init15() {this.pinLogin = (email, pin) => this.fetch('/quick_login', 'POST', { email, pin, ...this.authMetadata() })}
  __init16() {this.logout = () => this.fetch('/logout', 'POST')}
  __init17() {this.checkResetToken = (token) => this.fetch('/check_token', 'POST', { token })}
  __init18() {this.setPassword = (password, token) =>
    this.fetch('/set_password', 'POST', { password, reset_token: token })}

  __init19() {this.sendPasswordResetEmail = (email) => this.fetch('/send_reset_email', 'POST', { email })}
  __init20() {this.checkWelcomeCredential = (cred, path) =>
    this.fetch('/check_creds', 'POST', { cred, path })}

  __init21() {this.renewPatientConversationLink = (code) =>
    this.fetch('/renew_patient_link', 'POST', { code })}

  __init22() {this.checkPhone = (phone) => this.fetch('/check_phone', 'POST', { phone })}
  __init23() {this.checkWelcomeToken = (token) => this.fetch('/check_welcome_token', 'POST', { token })}
  __init24() {this.getSignupOrgMatches = (token) =>
    this.fetch('/signup/org_matches', 'POST', { token })}

  __init25() {this.getOnboardingPrices = () => this.fetch('/onboarding_prices')}
  __init26() {this.checkPassword = (password) => this.fetch('/check_password', 'POST', { password })}
  __init27() {this.confirmEmail = (token) => this.fetch('/confirm_email', 'POST', { token })}
  __init28() {this.unsubscribeEmailNotifs = (email, token) =>
    this.fetch('/unsubscribe_email_notifs', 'POST', { email: email, token: token })}

  __init29() {this.searchForOrgs = (q) =>
    this.fetch('/search_for_org', 'POST', { org_name: q })}

  __init30() {this.getQuickLoginUsers = () => this.fetch('/get_quick_login_users')}
  __init31() {this.removeQuickLoginUser = (userKey) => this.fetch(`/quick_login_users/${userKey}`, 'DELETE')}

  __init32() {this.log = (data) => this.fetch('/log', 'POST', data)}

  __init33() {this.submitSetup = (ps











) => this.fetch('/setup_welcome', 'POST', {
    Token: ps.token,
    First_name: ps.firstName,
    Last_name: ps.lastName,
    Email: ps.email,
    Phone: ps.phone,
    Password: ps.password,
    Orgs: JSON.stringify(ps.orgs),
    Signup_mfa_challenge_key: ps.signupMFAChallengeKey || '',
    Attribution: JSON.stringify(ps.signupAttribution || {}),
    ...(ps.agreements && { Agreements: JSON.stringify(ps.agreements) }),
    ...(ps.orgSurvey && {
      Referrer: ps.orgSurvey.referrer,
      Feature: ps.orgSurvey.features,
      // productInterest is a set; it form-encodes comma-joined ("sms,team_chat"),
      // matching the backend's comma-split parse (same path as Feature).
      Product_interest: ps.orgSurvey.productInterest,
      // Legacy-accepted backend fields; the retired sizing step leaves both empty.
      Team_size: ps.orgSurvey.teamSize,
      Patients_per_month: ps.orgSurvey.patientsPerMonth,
    }),
    Titles: [],
  })}

  __init34() {this.joinVideoChat = (videoKey, userKey) =>
    this.fetch('/join_video_chat', 'POST', { videoKey, userKey })}

  __init35() {this.checkVersion = (version) =>
    this.fetch(`/version?version=${version}`)}

  // Part order matters: the server checks `csrf` as soon as it arrives, so
  // sending it first lets a slow upload outlive the token's two-minute
  // lifetime. `upload` goes last so the small parts never wait behind it.
   __init36() {this.uploadFileWithCSRF = (csrf, upload, signal) =>
    this.fetch('/upload_file', 'POST', {
      csrf,
      ...(upload.durationMs !== undefined && { duration_ms: upload.durationMs }),
      ...(upload.poster && { poster: upload.poster }),
      upload,
    }, null, signal)}

   __init37() {this.uploadAvatarWithCSRF = (csrf, upload, signal) =>
    this.fetch('/upload_avatar', 'POST', { upload, csrf }, null, signal)}

  // A clinic's logo, square icon or team logo (clinic branding, P-1). The
  // answer's Path goes to SaveOrgBranding or UpdateTeam. `csrf` first, as
  // for /upload_file.
   __init38() {this.uploadOrgLogoWithCSRF = (csrf, orgKey, kind, upload, signal) =>
    this.fetch('/upload_org_logo', 'POST', { csrf, OrgKey: orgKey, Kind: kind, upload }, null, signal)}

  // A signed-in patient's own photo (M1). The answer's Ref goes to the
  // SetPatientPhoto command. `csrf` first, as for /upload_file.
   __init39() {this.uploadPatientPhotoWithCSRF = (csrf, upload, signal) =>
    this.fetch('/patient/upload_photo', 'POST', { csrf, upload }, null, signal)}

   __init40() {this.superImpersonateWithCSRF = (csrf, userKey) =>
    this.fetch('/super/impersonate', 'POST', { user_key: userKey, csrf })}
} exports.FetchCommands = FetchCommands;
